import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const defaultToastOptions = {
  position: "top-center",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

export function useAppFeedback() {
  const navigate = useNavigate();

  const showSuccess = (message, options = {}) => {
    const { redirectTo, redirectDelay = 1200 } = options;
    toast.success(message, defaultToastOptions);

    if (redirectTo) {
      window.setTimeout(() => {
        navigate(redirectTo);
      }, redirectDelay);
    }
  };

  const showError = (message) => {
    toast.error(message, defaultToastOptions);
  };

  return {
    showError,
    showSuccess,
  };
}
